// Baby-tooth eruption/shedding ages follow the ADA primary-teeth chart.
export const TOOTH_TYPES = {
  central: {
    kidName: "Front Biter", name: "Central incisor",
    up: ["8–12 months", "6–7 years"], low: ["6–10 months", "6–7 years"],
    kid: "These are usually the very first teeth to pop out - and the first to get wobbly! The Tooth Fairy loves them.",
    parent: "Start brushing as soon as the first tooth appears with a rice-grain smear of fluoride toothpaste, twice a day (AAPD).",
  },
  lateral: {
    kidName: "Side Biter", name: "Lateral incisor",
    up: ["9–13 months", "7–8 years"], low: ["10–16 months", "7–8 years"],
    kid: "Side biters help you bite into apples, rotis and sandwiches. Crunch!",
    parent: "Chalky white spots near the gumline on front teeth can be early decay - it can often be reversed if caught early, so mention it at check-ups.",
  },
  canine: {
    kidName: "Pointy Tooth", name: "Canine",
    up: ["16–22 months", "10–12 years"], low: ["17–23 months", "9–12 years"],
    kid: "Your sharpest teeth - just like a tiny lion's! They help tear chewy food.",
    parent: "For teething soreness, a clean chilled (not frozen) teething ring helps. Avoid benzocaine teething gels for young children (US FDA warning).",
  },
  molar1: {
    kidName: "Chomper", name: "First molar",
    up: ["13–19 months", "9–11 years"], low: ["14–18 months", "9–11 years"],
    kid: "Chompers are big and flat - they grind your food like a mixer grinder!",
    parent: "Molars have deep grooves where food sticks. Brush the chewing surfaces well and start flossing once teeth touch each other.",
  },
  molar2: {
    kidName: "Mega Chomper", name: "Second molar",
    up: ["25–33 months", "10–12 years"], low: ["23–31 months", "10–12 years"],
    kid: "The last baby teeth to arrive - and they stay with you until you're about 10 to 12!",
    parent: "Baby molars hold space for adult teeth. Losing them early to decay can cause crowding, so keep them healthy until they fall out naturally.",
  },
};

const SIDE = ["molar2", "molar1", "canine", "lateral", "central"];
export const ARCH = [...SIDE, ...[...SIDE].reverse()];

export const AGE_STAGES = [
  {
    label: "0–1 yr", title: "Baby's first tooth", teeth: "0–8 teeth",
    kid: "Your first tooth peeks out around 6 months. Hello, tooth!",
    tips: ["Wipe gums with a soft, clean cloth after feeds", "First tooth usually appears around 6 months", "First dental visit by the 1st birthday (AAPD)", "Don't put baby to sleep with a milk bottle"],
  },
  {
    label: "1–3 yrs", title: "Teething toddler", teeth: "Up to 20 baby teeth",
    kid: "More and more teeth are arriving - you'll have 20 by about age 3!",
    tips: ["Rice-grain smear of fluoride toothpaste, twice daily", "Parents do the brushing", "Move from bottle to an open cup around age 1", "Limit juice and sticky snacks between meals"],
  },
  {
    label: "3–6 yrs", title: "Full baby smile", teeth: "20 baby teeth",
    kid: "All 20 baby teeth are here. Brush for 2 minutes - try the Fun Zone timer!",
    tips: ["Pea-sized amount of fluoride toothpaste", "Help or supervise brushing - kids need help until ~7–8", "Check-ups about every 6 months", "Gently wean thumb-sucking/pacifier by age 3–4"],
  },
  {
    label: "6–12 yrs", title: "Wiggly teeth & big teeth", teeth: "Baby + adult teeth mix",
    kid: "Wobbly teeth fall out and grown-up teeth move in. Your smile is changing!",
    tips: ["First adult molars come in ~age 6, behind baby teeth", "Ask about sealants for new permanent molars", "Orthodontic check by age 7 (AAO)", "Mouthguard for cricket, football and other sports"],
  },
  {
    label: "12+ yrs", title: "Teen smile", teeth: "28 adult teeth (+4 wisdom later)",
    kid: "You've got your grown-up smile! Keep it shining for life.",
    tips: ["Most permanent teeth are in by 12–13", "Floss daily, especially with braces", "Avoid frequent soft drinks and energy drinks", "Wisdom teeth usually appear between 17–21"],
  },
];
